var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTea(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.66 10.1144H11.92C6.46002 10.1144 2 14.6066 2 20.1511V34.9633C2 40.4875 6.44002 45 11.92 45H26.66C32.12 45 36.58 40.4875 36.58 34.9633V20.1511C36.58 14.6268 32.14 10.1144 26.66 10.1144V10.1144ZM33.58 34.9633C33.58 38.8283 30.48 41.9647 26.66 41.9647H11.92C8.10002 41.9647 5 38.8283 5 34.9633V20.1511C5 16.2861 8.10002 13.1497 11.92 13.1497H26.66C30.48 13.1497 33.58 16.2861 33.58 20.1511V34.9633Z",
    fill: "#03182F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.58 26.7882V34.9633C31.58 37.7153 29.36 39.9411 26.66 39.9411H11.92C9.20001 39.9411 7 37.7153 7 34.9633V26.7882H31.58V26.7882Z",
    fill: "#FF8A00"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 8.57647C9.68 8.57647 9 7.88847 9 7.05882V3.51765C9 2.688 9.68 2 10.5 2C11.32 2 12 2.688 12 3.51765V7.05882C12 7.88847 11.32 8.57647 10.5 8.57647Z",
    fill: "#03182F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5 8.57647C17.68 8.57647 17 7.88847 17 7.05882V3.51765C17 2.688 17.68 2 18.5 2C19.32 2 20 2.688 20 3.51765V7.05882C20 7.88847 19.32 8.57647 18.5 8.57647Z",
    fill: "#03182F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5 8.57647C25.68 8.57647 25 7.88847 25 7.05882V3.51765C25 2.688 25.68 2 26.5 2C27.32 2 28 2.688 28 3.51765V7.05882C28 7.88847 27.32 8.57647 26.5 8.57647Z",
    fill: "#03182F"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M35.08 35.631C34.26 35.631 33.58 34.943 33.58 34.1134V17.0753C33.58 16.2456 34.26 15.5576 35.08 15.5576C40.56 15.5576 45 20.0701 45 25.5943C45 31.1186 40.54 35.631 35.08 35.631V35.631ZM36.58 18.7548V32.4338C39.68 31.7458 42 28.9331 42 25.5943C42 22.2555 39.68 19.4428 36.58 18.7548V18.7548Z",
    fill: "#03182F"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M36.02 23.2471C36.02 24.0767 35.34 24.7647 34.52 24.7647H3.5C2.68 24.7647 2 24.0767 2 23.2471C2 22.4174 2.68 21.7294 3.5 21.7294H34.52C35.34 21.7294 36.02 22.4174 36.02 23.2471Z",
    fill: "#03182F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTea);
export default __webpack_public_path__ + "static/media/tea.25da0c35befd33ea4c6466d7f6948d1e.svg";
export { ForwardRef as ReactComponent };